var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.087 1.694 2.767 5.617c.198.33.527.594.922.66l6.193.926c.988.132 1.384 1.387.659 2.114l-4.48 4.362c-.263.264-.395.66-.33 1.057l1.055 6.145a1.191 1.191 0 0 1-1.779 1.256l-5.534-2.908a1.129 1.129 0 0 0-1.12 0l-5.534 2.908a1.217 1.217 0 0 1-1.779-1.256l1.054-6.145a1.221 1.221 0 0 0-.33-1.057L1.373 11.01c-.725-.727-.33-1.916.659-2.114l6.193-.925c.395-.067.724-.33.922-.661l2.767-5.617c.395-.925 1.713-.925 2.174 0z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.023
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar12);
export default __webpack_public_path__ + "static/media/star12.d0298806.svg";
export { ForwardRef as ReactComponent };